<template>
    <div class="x-tab-view">
        <x-tab :config="getTabConfig(config)" :readonly="readonly" :data="data" :query-params="queryParams">
            <template #default="field">
                <x-form-view v-if="field.config.type == FieldType.FORM" :config="field.config.config"
                    :readonly="field.readonly || field.config.readonly" :query-params="field.queryParams"
                    :view-state="viewState" :proxy="proxy" :pcode="getFullCode(field.config.config)"></x-form-view>
                <x-table-view v-else-if="field.config.type == FieldType.TABLE" :config="field.config.config"
                    :readonly="field.readonly || field.config.readonly" :query-params="field.queryParams"
                    v-model:selected="selected" :proxy="proxy" :pcode="getFullCode(field.config.config)"></x-table-view>
                <x-module-view v-else-if="viewState != ViewState.EDIT && field.config.type == FieldType.PAGE"
                    :config="field.config" :readonly="field.readonly || field.config.readonly" :proxy="proxy"
                    :pcode="getFullCode(field.config)"></x-module-view>
            </template>
        </x-tab>
    </div>
</template>
<script setup>
import { defineProps, ref, watch } from 'vue';
import FieldType from '../datamodule/FieldType';
import ViewState from '../viewmodule/ViewState';
import XTab from '../components/data/XTab.vue';
import XFormView from './XFormView.vue';
import XTableView from './XTableView.vue';
import XModuleView from './XModuleView.vue';
import { useRoute } from 'vue-router';
import PermissionManager from '../permission/PermissionManage';
import MenuApi from '../view/menu/api';
import { Axios } from 'axios';
const route = useRoute();
const props = defineProps({
    config: { default: null },
    readonly: { default: false },
    data: { default: null },

    queryParams: { default: null },
    viewState: { default: null },

    proxy: { default: null },
    pcode: { default: null },
})

const getFullCode = (config) => {
    return (props.pcode || '') + (config.code ? config.code : '');
}
const getModule = (config) => {
    return config?.body?.fields[0]?.config?.view.getModuleCode() || ''
}
const getTabConfig = (config) => {
    let api = []
    for (const field of config.fields) {
        field.fullCode = getFullCode(field);
        field.fullModule = getModule(field);

        let arr = [];
        let query = '';
        for (const key in field.filter) {
            let par = '';
            if (Array.isArray(field.filter[key])) {
                console.log()
                par = field.filter[key].toString()
            } else if (Object.getPrototypeOf(field.filter[key]) === Object.prototype) {
                console.log(Object.getPrototypeOf(field.filter[key]))
                let arrs = [];
                for (const keys in field.filter[key]) {
                    arrs.push(`${keys}=${field.filter[key][keys]}`)
                }
                par = '(' + arrs.join('&') + ')'

            } else {
                par = field.filter[key]
            }
            arr.push(`${key}=${par}`)
        }
        query += arr.join('&')
        // let query = new URLSearchParams(f).toString()
        // if (PermissionManager.getSubMenu(route.path).length == 0) {
        //     let params = {
        //     }
        //     let it = PermissionManager.getMenu(route.path)[0]
        //     params.parentId = it.menuId;
        //     params.menuName = field.name;
        //     params.orderNum = it.orderNum;
        //     params.component = field.fullModule;
        //     params.isFrame = it.isFrame;
        //     params.isCache = it.isCache;
        //     params.path = field.fullCode;
        //     params.menuType = "F";
        //     params.visible = it.visible;
        //     params.status = it.status;
        //     params.perms = it.fullModule;
        //     params.query = query
        //     params.priviledgeScope = it.priviledgeScope;
        //     params.systemId = it.systemId;
        //     params.pcode = it.pcode;
        //     params.label = it.label;
        //     params.colourType = it.colourType;
        //     params.roleType = it.roleType;
        //     console.log(params)
        //     api.push(MenuApi.addMenu(params))

        // }

    }
    // Promise.all(api).then(
    //   res=>{
    //     MenuApi.getPermission().then(response => {
    //         PermissionManager.updatePermissions(response.data);

    //     })
    //   }
    // )
    return config;
}

const selected = ref(null);

// const getConfig = (config)=> {
//     console.log('tab config', config);
//     return config;
// }

const dataView = ref(null);
watch(() => props.config?.view, (value) => {
    dataView.value = value;
}, { immediate: true })
</script>
<style scoped>
.x-tab-view {
    background: #fff;
}

.x-tab-view>>>.el-tabs__header {
    margin: 0;
}

.x-tab-view>>>.el-tabs__nav-wrap:after {
    height: 1px;
}
</style>